import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

/**
 * Constrains wide Specifics grids on narrow viewports.
 * SettingsSubpage uses overflow-x-clip, so grids need an inner scroll
 * container (same pattern as Team administrators table).
 */
export const ScrollablePrefsGrid = ({ children, className }: Props) => (
  <div
    className={[
      'w-full min-w-0 max-w-full overflow-x-auto overscroll-x-contain pb-1',
      // Visible horizontal scrollbar affordance (Firefox + WebKit/Blink)
      '[scrollbar-width:thin]',
      '[&::-webkit-scrollbar]:h-1.5',
      '[&::-webkit-scrollbar-thumb]:rounded-full',
      '[&::-webkit-scrollbar-thumb]:bg-outline-variant',
    ].join(' ')}
  >
    <div className={className}>{children}</div>
  </div>
);
